import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

export const updateNativeStatusBar = async (isDark = false) => {
  if (Capacitor.isNativePlatform()) {
    try {
      await StatusBar.setStyle({
        style: isDark ? Style.Dark : Style.Light,
      });
      await StatusBar.setBackgroundColor({
        color: isDark ? '#020617' : '#ffffff',
      });
    } catch (e) {
      // Ignore if status bar unsupported
    }
  }
};
